const NoteSectionUpdateProfile = () => {
    return (
        <div
            style={{
                background: '#e7f3fe',
                borderLeft: '6px solid #2196F3',
                padding: '3px 5px 5px 5px',
                display: 'flex',
                flexDirection: 'column',
                width: '85%',
            }}>
            <div style={{ padding: '5px 0px 0px 5px' }}>
                <strong>
                    Please confirm whether you choose to provide your cell phone
                    number. If you opt in, please note:
                </strong>
            </div>
            <ul style={{ listStyleType: 'disc', paddingLeft: '25px' }}>
                <li>You agree to receive assistance via text messaging.</li>
                <li>Message and data rates may apply.</li>
                <li>
                    <strong>
                        We will only send a text message if you request to reset
                        your password.
                    </strong>
                </li>
                <li>
                    You will receive text messages at the cell phone number
                    provided during the registration process.
                </li>
                <li>
                    For more information on privacy, visit: &nbsp;
                    <a
                        href="https://www.utsystem.edu/privacy"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://www.utsystem.edu/privacy
                    </a>
                </li>
            </ul>
        </div>
    )
}
export default NoteSectionUpdateProfile
